<template>
  <div>
    <!-- 创意名称 -->
    <div v-if="formKey === 'creative_name' && !formItem.isPreview">
      <el-link v-for="word in formItem.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertWord(`{${word}}`, formItem)">+{{ word }}</el-link>
    </div>
    <component
      :is="getDynamicComponentName()"
      v-if="getDynamicComponentName()"
      :form-key="formKey"
      :form-item="formItem"
      :form-fields="formFields"
      :init-ops="initOps"
    />
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
export default {
  props: {
    ...component_props,
  },
  data() {
    return {
      // 动态渲染组件表
      dynamic_component_map: {
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/base-form/channel-interface/bilibili/index.vue'),
      },
    };
  },
  methods: {
    /**
     * 获取动态表单名称
     * @returns {Function | null}
     */
    getDynamicComponentName() {
      const { channel_interface } = this.initOps;
      const form = this.dynamic_component_map[channel_interface];
      return form || null;
    },
    /**
     * 插入通配符
     * @param word 通配符
     * @param form_item 表单项
     */
    insertWord(word, form_item) {
      const name = form_item.value;
      const match_list = name.match(/{[^}{]*?}/g) || [];
      form_item.value = match_list.includes(word) ? name.replace(word, '') : name.concat(word);
    },
  },
};
</script>
